import { useEffect } from "react";
import { useRsnFeeHandler } from "src/hooks/useRsnFeeHandler";
import { deleteCookie } from "src/utils/deleteCookie";

export function ClientPageBootstrap() {
  // US: Delete cookie "intent" if found in any page of Upper Funnel for shop team WAT-5799
  useEffect(() => {
    /**
    * @see {@link https://directv-it.atlassian.net/browse/WAT-8043}
    */
    const params = new URLSearchParams(window.location.search);
    if (params?.get('retainCookie') !== 'true') {
      deleteCookie('intent');
    }
  }, []);
  useRsnFeeHandler();
  return null;
}
